import React, { useContext } from 'react';
import ConfigContext from '../../../contexts/ConfigContext';
import { useGetBlogCategoriesQuery } from '../../../redux/slices/blogCategorySlice';

// Components
import Hero from '../content/Hero';
import QuoteCta from '../content/QuoteCta';
import Meta from '../../shared/Meta';
import BlogSidebar from './BlogSidebar';
import FeaturedBlogPosts from './FeaturedBlogPosts';
import SimpleCta from '../content/SimpleCta';

import sidebarStyles from '../../../../stylesheets/public/layouts/SidebarLayout.module.postcss';
import CateringCta from '../content/CateringCta';

function BlogPosts() {
  const { vehicle_type, city_name } = useContext(ConfigContext);
  const vehicleType = vehicle_type.toLowerCase();

  const { data = {} } = useGetBlogCategoriesQuery();
  const blogCategories = data.blog_categories || [];

  return (
    <div>
      <Meta
        title='The Blog'
        breadcrumbName='Blog'
        type='website'
        description={`Stories, guides, and updates from ${city_name}'s food ${vehicleType} scene. Explore catering tips, vendor spotlights, and local food ${vehicleType} news.`}
      />

      <Hero photo='https://static.seattlefoodtruck.com/photos/home-hero.webp' />

      <div className='Section Section--extraPadding u-pb0'>
        <h1 className='u-mb0'>News & Stories</h1>
      </div>

      <div className='Section Section--extraPadding'>
        <div className={sidebarStyles.SidebarLayout}>
          <div className={sidebarStyles.SidebarLayout_body}>

            <section className='InnerSection u-pt0'>
              <FeaturedBlogPosts count={3} />
            </section>

            <div className='InnerSection'>
              <h2 className='u-mb1'>All Categories</h2>
              <hr className='u-mb2' />
              <QuoteCta />
            </div>

            { blogCategories.map((category) => {
              if (category.post_count === 0) return null;
              return (
                <React.Fragment key={category.uid}>
                  <section className='InnerSection'>
                    <FeaturedBlogPosts title={category.name} categoryId={category.uid} />
                  </section>

                  <section className='InnerSection'>
                    <SimpleCta
                      text={`Read stories of your favorite ${city_name} food ${vehicleType}s`}
                      link={'/blog/category/' + category.id}
                      linkTitle='Read More'
                    />
                  </section>
                </React.Fragment>
              );
            }) }

          </div>
          <div className={sidebarStyles.SidebarLayout_sidebar}>
            <BlogSidebar />
          </div>
        </div>
      </div>

      {/* TODO instagram posts */}

      <section className='Section--extraPadding u-pt0'>
        <CateringCta title={<><span aria-hidden='true'>🚚 </span>Book a Food {vehicle_type} for Your Event!</>} />
      </section>
    </div>
  );
}

export default BlogPosts;
